// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1981Q","disabled":"FileBtn_disabled__tcK7F","warn":"FileBtn_warn__igD8i","fade":"FileBtn_fade__iZH-p"};